import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { KnBrFindMyContactSearchComponent } from './kn-br-find-my-contact-search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormErrorsModule } from '@spartacus/storefront';
import { KnBrCustomerContextGuard } from 'src/app/shared/guards/kn-br-customer-context.guard';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        I18nModule,
        NgbModule,
        FormErrorsModule,
        NgSelectModule,
        NgbTooltipModule,
        ConfigModule.withConfig({
            cmsComponents: {
                CarlisleFindMyContactHeaderComponent: {
                    component: KnBrFindMyContactSearchComponent,
                    guards: [AuthGuard, KnBrCustomerContextGuard],
                },
            },
        } as CmsConfig),
        KnBrFindMyContactSearchComponent,
    ]
})
export class KnBrFindMyContactSearchModule { }
